import { render, staticRenderFns } from "./boolean-list-type.vue?vue&type=template&id=b325eb36&scoped=true&lang=pug&"
import script from "./boolean-list-type.vue?vue&type=script&lang=ts&"
export * from "./boolean-list-type.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b325eb36",
  null
  
)

export default component.exports